<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" :alt="altText" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400" >
       <!-- <h1>Cam kết bảo mật</h1> -->
       <!-- <div class="title-line"></div> -->
       <div class="textBox" style="white-space: pre-wrap">{{text}}</div>
       
      </div>
    </div>
 
  </div>
</template>

<script>
import importedImg1 from "@/page/thaiintercompany/components/img/4_1.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      text:`พวกเราใส่ใจในความเป็นส่วนตัวของลูกค้าของเรา ดังนั้นเราจึงเผยแพร่นโยบายความเป็นส่วนตัวนี้ (“นโยบาย”) เพื่อแจ้งให้ลูกค้าทราบถึงนโยบายของเราที่เกี่ยวข้องกับการรวบรวม การใช้และการเปิดเผยข้อมูลส่วนบุคคลของบุคคล (“คุณ”) ตามกฎหมายและข้อบังคับที่เกี่ยวข้อง บริษัทของเราจะรวบรวมและใช้ข้อมูลส่วนบุคคลของคุณตามขอบเขตที่คุณยินยอมเท่านั้นเมื่อได้รับอนุญาตอย่างชัดแจ้งจากทางคุณ 
1.เรารวบรวมข้อมูลส่วนบุคคลของคุณยังไง
เรารวบรวมข้อมูลส่วนบุคคลของคุณเฉพาะในกรณีที่จำเป็นหรือมีพื้นฐานทางกฎหมายในการรวบรวมเท่านั้น ซึ่งรวมถึงที่ที่เรารวบรวมข้อมูลส่วนบุคคลของคุณตามมูลเหตุที่ถูกต้องตามกฎหมายของข้อผูกมัดทางกฎหมาย การปฏิบัติตามสัญญาที่คุณทำกับเรา ผลประโยชน์โดยชอบด้วยกฎหมายของเรา การปฏิบัติภายใต้ความยินยอมของคุณ และพื้นฐานทางกฎหมายอื่น ๆ การใช้แอปพลิเคชันนี้ สินเชื่อฉับไว คุณได้ให้ความยินยอมโดยชัดแจ้งในการเก็บรวบรวมข้อมูลส่วนบุคคลของคุณด้วยวิธีต่อไปนี้:
1.1 ข้อมูลส่วนบุคคลพื้นฐานที่ผู้ใช้ให้ไว้
เมื่อลงทะเบียนเป็นผู้ใช้ คุณจะให้ข้อมูลต่อไปนี้ตามความคิดริเริ่มของคุณเองระหว่างการใช้แอปพลิเคชันนี้: (1)ชื่อเต็ม (2)วันเกิด (3)เพศ (4)ที่อยู่ (5)ผู้ติดต่อในกรณีฉุกเฉิน, (6) ข้อมูล ID, (7) ข้อมูลบัญชีธนาคารของผู้รับผลประโยชน์
1.2 ข้อมูลที่รวบรวมระหว่างการใช้บริการ
เรารวบรวมข้อมูลเกี่ยวกับแอปพลิเคชันและอุปกรณ์ที่คุณใช้เพื่อเข้าถึงบริการของเรา ข้อมูลและการอนุญาตที่เรารวบรวมประกอบด้วย:
1.2.1 ที่ตั้ง
เราจะรวบรวมข้อมูลตำแหน่งทางภูมิศาสตร์ของคุณในเบื้องหน้าเมื่อคุณโต้ตอบกับแอปพลิเคชันนี้ เราจะยุติการรวบรวมข้อมูลตำแหน่งทางภูมิศาสตร์ของคุณเมื่อแอปพลิเคชันนี้ทำงานอยู่เบื้องหลัง คุณสามารถเลือกที่จะปิดใช้งานข้อมูลการติดตามตำแหน่งทางภูมิศาสตร์บนอุปกรณ์เคลื่อนที่ของคุณเป็นการชั่วคราวได้เสมอ
1.2.2 กล้อง
เราต้องได้รับอนุญาตจากกล้องเพื่อให้คุณสามารถถ่ายภาพเอกสาร KYC ของคุณพร้อมกับเอกสารที่จำเป็นอื่นๆ และอัปโหลดเอกสารเดียวกันบนแอปพลิเคชันนี้
การอนุญาตให้เข้าถึงปฏิทินของคุณช่วยให้เราเตือนคุณถึงวันครบกำหนดชำระคืน
1.2.3 SMS
เราตรวจสอบเฉพาะ SMS ทางการเงิน (SMS ทางการเงิน 4 หลัก) ซึ่งรวมถึงผู้ส่ง คำอธิบาย และวันที่ที่ส่งในกล่องจดหมายของผู้ใช้ ซึ่งช่วยให้เราระบุบัญชีต่างๆ ที่ผู้ใช้ถืออยู่และรูปแบบกระแสเงินสดที่เป็นของผู้ใช้ เพื่อช่วยเรากำหนด โปรไฟล์ความเสี่ยงของผู้ใช้และจัดทำการวิเคราะห์เครดิตที่เหมาะสมสำหรับผู้ใช้ นอกจากนี้ เรารวบรวมและประมวลผลข้อมูลโทรศัพท์ เช่น บันทึก SMS สำหรับการวิเคราะห์ความเสี่ยง เพื่อประเมินสิทธิ์ของผู้ใช้ในการใช้ผลิตภัณฑ์หรือบริการของเรา (รวมถึงแต่ไม่จำกัดเพียง โดยการประเมินความน่าเชื่อถือของผู้ใช้ พิจารณาว่าผู้ใช้สามารถซื้อผลิตภัณฑ์หรือบริการที่ผู้ใช้ร้องขอ และ/หรือพิจารณาว่าผู้ใช้ มีสิทธิ์ได้รับสิทธิประโยชน์เพิ่มเติมจากผลิตภัณฑ์ที่มีอยู่) เพื่อให้บริการเงินกู้แก่ผู้ใช้ (รวมถึงแต่ไม่จำกัดเฉพาะโดยการประมวลผลธุรกรรมของคุณและประมวลผลการชำระเงินกู้ของผู้ใช้และรวบรวมการชำระคืนเงินกู้ของผู้ใช้) การตรวจสอบตัวตนของผู้ใช้และ/หรือข้อมูลอื่นๆ ที่ผู้ใช้ให้ไว้กับเรา; ตรวจจับ ต่อสู้ และป้องกันการฉ้อโกง พยายามฉ้อโกง ฟอกเงิน และ/หรือการใช้บริการของเราอย่างผิดกฎหมาย การวิเคราะห์พฤติกรรมของลูกค้า การติดต่อกับหน่วยงานอ้างอิงเครดิตหรือการป้องกันการฉ้อโกง และให้บริการหรือสนับสนุนลูกค้า
เพื่อติดต่อคุณโดยใช้ข้อความ (SMS) (ถ้ามี) ตามวัตถุประสงค์ที่อธิบายไว้ในนโยบายความเป็นส่วนตัวนี้
ข้อมูล SMS จะถูกเข้ารหัสและอัปโหลดไปยังเซิร์ฟเวอร์ของเรา api.cherrybk.com ผ่านแอปพลิเคชัน แต่เราจะกรองและลบข้อมูล SMS ส่วนตัวออกจากเซิร์ฟเวอร์ของเราในครึ่งปีให้หลัง และเราจะไม่เปิดเผยข้อมูลนี้กับบุคคลที่สาม หากคุณต้องการลบข้อมูล SMS ทันที คุณต้องแจ้งศูนย์บริการลูกค้าของเราทางอีเมล
1.2.4 ข้อมูลอุปกรณ์อื่นๆ
เมื่อคุณใช้แอปพลิเคชันนี้ เซิร์ฟเวอร์ของเราจะบันทึกข้อมูลอุปกรณ์บางอย่างโดยอัตโนมัติ ซึ่งส่งมาจากอุปกรณ์เคลื่อนที่ของคุณ ซึ่งรวมถึงยี่ห้ออุปกรณ์ รุ่น รุ่นระบบปฏิบัติการ สภาพแวดล้อมเครือข่ายอุปกรณ์ WiFi สถานะอุปกรณ์ ข้อมูลซอฟต์แวร์แอปพลิเคชัน ข้อมูลหน่วยความจำอุปกรณ์ การอนุญาตให้เข้าถึงข้อมูลนี้ช่วยให้เราสามารถระบุตัวตนของผู้ใช้และความชอบของคุณ และแนะนำผลิตภัณฑ์เครดิตที่เหมาะสม
ข้อมูลข้างต้นทั้งหมดจะไม่ถูกเก็บไว้อย่างถาวรและจะถูกลบหลังการใช้งาน
2. เราใช้ข้อมูลส่วนบุคคลของคุณอย่างไร
2.1 เราจะประมวลผลข้อมูลส่วนบุคคลของคุณเป็นหลักเพื่อให้บริการหรือผลิตภัณฑ์ที่คุณร้องขอ อย่างไรก็ตาม อาจมีบางครั้งที่เราจำเป็นต้องประมวลผลข้อมูลส่วนบุคคลที่ไม่ได้เป็นส่วนหนึ่งของธุรกิจหลักของเรา ตัวอย่างเช่น เมื่อเราต้องปฏิบัติตามภาระผูกพันทางกฎหมายหรือหน้าที่สาธารณะที่กฎหมายกำหนด
2.2 เราอาจใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์ดังต่อไปนี้:
• ช่วยเหลือคุณในการลงทะเบียนและขั้นตอนการยืนยันตัวตน;
• การขอสินเชื่อ;
• การสาธิตผลิตภัณฑ์และ/หรือบริการ;
• เพิ่มความปลอดภัยให้กับผลิตภัณฑ์และ/หรือบริการของเรา;
• แก้ไขปัญหาใด ๆ ที่คุณอาจพบโดยใช้ผลิตภัณฑ์และ/หรือบริการของเรา
เราจะเก็บข้อมูลส่วนบุคคลของคุณตราบเท่าที่กฎหมายกำหนดและจำเป็นเพื่อให้บรรลุวัตถุประสงค์ในการรวบรวมและใช้ข้อมูล เมื่อข้อมูลส่วนบุคคลของคุณเกินระยะเวลาการเก็บรักษา เราจะลบข้อมูลส่วนบุคคลของคุณหรือไม่เปิดเผยตัวตนตามข้อกำหนดทางกฎหมายที่บังคับใช้
3. วิธีที่เราเปิดเผยและถ่ายโอนข้อมูลส่วนบุคคลของคุณ
เราจะไม่แบ่งปันข้อมูลส่วนบุคคลของคุณกับบุคคลที่สามเพื่อใช้ในเชิงพาณิชย์หรือการตลาดโดยไม่ได้รับความยินยอมจากคุณ เมื่อยอมรับนโยบายความเป็นส่วนตัวนี้ เราจะแบ่งปันข้อมูลส่วนบุคคลของคุณกับบุคคลที่สามภายใต้สถานการณ์ต่อไปนี้:
• การเปิดเผยต่อพนักงานที่ได้รับอนุญาตของบริษัทและบริษัทในเครือ รวมถึงผู้สอบบัญชีของบริษัทหรือผู้สอบบัญชีภายนอก สหกรณ์สถาบันการเงิน และ/หรือบุคคลภายนอกที่เกี่ยวข้องกับบริษัทของเรา;
• การเปิดเผยเพื่อให้คุณสามารถซื้อขายและ/หรือใช้บริการที่คุณต้องการ;
• การเปิดเผยข้อมูลต่อเครดิตบูโร (หน่วยงานรายงานข้อมูลเครดิตประเภทหนึ่ง);
• การเปิดเผยภายใต้การสอบสวนทางกฎหมายหรือการดำเนินการทางกฎหมาย;
• การเปิดเผยตามกฎหมาย คำสั่งของรัฐบาล หรือข้อกำหนดของกฎระเบียบ
นอกจากฝ่ายต่างๆ ที่ระบุไว้ข้างต้นแล้ว เรายังทำสัญญากับบริษัทบุคคลที่สามอื่นๆ เพื่อช่วยให้คุณสมัครสินเชื่อได้สำเร็จ ซึ่งรวมถึง: สถาบันสหกรณ์บุคคลที่สาม เช่น ผู้ให้กู้กองทุน พันธมิตรการชำระเงิน พันธมิตรหลังเงินกู้ การตรวจสอบบุคคลที่สาม ผู้ให้บริการ ผู้ให้บริการข้อความ พันธมิตรบริการโทรออก
4. สิทธิ์ในข้อมูลของคุณ
คุณมีสิทธิ์บางประการเกี่ยวกับข้อมูลส่วนบุคคลของคุณ สิทธิ์เหล่านี้รวมถึง:
• สิทธิ์ในการเข้าถึงข้อมูลส่วนบุคคลของคุณ
• สิทธิ์ในการแก้ไขหรือปรับปรุงข้อมูลส่วนตัวของคุณ
• สิทธิ์ในการพกพา
• สิทธิ์ในการเพิกถอนความยินยอมหากคุณได้ให้ไว้ก่อนหน้านี้
• สิทธิ์ในการยื่นเรื่องร้องเรียนต่อหน่วยงานคุ้มครองข้อมูล
หากคุณต้องการส่งคำขอเกี่ยวกับสิทธิ์ของคุณ โปรดติดต่อฝ่ายสนับสนุนลูกค้า โปรดทราบว่าเราอาจต้องขอข้อมูลเพิ่มเติมจากคุณเพื่อดำเนินการตามคำขอการสื่อสารจากคุณ (เช่น คำขอบริการ)
5. เราปกป้องข้อมูลอย่างไร
เราเข้าใจถึงความสำคัญของการรักษาข้อมูลของคุณให้ปลอดภัย เราใช้ความพยายามตามสมควรในการปกป้องข้อมูลส่วนบุคคลของคุณและรับประกันความปลอดภัยของระบบของเรา เพื่อปกป้องข้อมูลส่วนบุคคลของคุณจากการเข้าถึงและใช้งานโดยไม่ได้รับอนุญาต เราใช้มาตรการรักษาความปลอดภัยที่สอดคล้องกับกฎหมายที่บังคับใช้ มาตรการเหล่านี้รวมถึงการป้องกันคอมพิวเตอร์และไฟล์ที่ปลอดภัย หากคุณพบการรั่วไหลของข้อมูลส่วนบุคคลที่น่าสงสัย โปรดติดต่อเราทันที
นอกจากมาตรการรักษาความปลอดภัยทั่วไปข้างต้นแล้ว บริษัทของเรายังใช้เทคโนโลยีความปลอดภัยขั้นสูงต่อไปนี้เพื่อปกป้องข้อมูลส่วนบุคคลของคุณ:
• การตรวจจับการบุกรุก: ระบบซอฟต์แวร์ที่ใช้ในการตรวจจับและป้องกันการโจมตีของบุคคลที่ไม่ได้รับอนุญาต บริษัทของเราใช้ระบบที่มีประสิทธิภาพและจะปรับปรุงระบบดังกล่าวเป็นประจำ
• ไฟร์วอลล์: ระบบซอฟต์แวร์ที่อนุญาตเฉพาะพนักงานที่ได้รับอนุญาตจากบริษัทของเราเท่านั้นที่สามารถเข้าถึงข้อมูลส่วนตัวของคุณได้ บริษัทของเราใช้ระบบป้องกันไฟร์วอลล์คู่
• การสแกนไวรัส: บริษัทของเราติดตั้งซอฟต์แวร์ป้องกันไวรัสที่มีประสิทธิภาพในระบบของบริษัทเป็นประจำ และติดตั้งซอฟต์แวร์สแกนไวรัสบนเซิร์ฟเวอร์โดยเฉพาะ
• การเข้ารหัสในการเข้าถึงข้อมูล: เทคโนโลยีการเข้ารหัสที่ใช้ในการเข้าถึงข้อมูลเพื่อป้องกันการดักฟังระหว่างการส่งผ่านอินเทอร์เน็ต โดยการใช้เทคโนโลยีนี้ บุคคลที่ตั้งใจจะดักข้อมูลหรือบุคคลที่ไม่ได้รับอนุญาติไม่สามารถเข้าใจความหมายของข้อมูลที่จับได้ เทคโนโลยีนี้สามารถใช้เพื่อตรวจสอบการมีอยู่ของเว็บไซต์ของบริษัท ซึ่งใช้ SSL 128 บิต (SSL.1 สำหรับการส่งข้อมูล)
• การเข้ารหัสข้อมูล: ใช้สำหรับข้อมูลที่ละเอียดอ่อนมาก บริษัทใช้มาตรการรักษาความปลอดภัยที่เข้มงวด ก่อนที่จะนำข้อมูลเข้าสู่ฐานข้อมูลคอมพิวเตอร์ของบริษัท จะใช้อัลกอริทึมที่ซับซ้อนในการเข้ารหัส ดังนั้นจึงไม่มีใครแม้แต่พนักงานของบริษัทจะทราบข้อมูลที่ละเอียดอ่อนดังกล่าว
• คุกกี้: ไฟล์ขนาดเล็กในคอมพิวเตอร์ที่สามารถเก็บข้อมูลสำคัญไว้ในคอมพิวเตอร์ได้ชั่วคราวเพื่ออำนวยความสะดวกในการสื่อสารโทรคมนาคม บริษัทของเราให้ความสำคัญอย่างยิ่งต่อความเป็นส่วนตัวของคุณ ดังนั้น โปรดใช้คุกกี้ด้วยความระมัดระวัง อย่างไรก็ตาม หากจำเป็นต้องใช้คุกกี้
บริษัทของเราจะพิจารณาอย่างรอบคอบและให้ความสำคัญกับความปลอดภัยและความเป็นส่วนตัวของคุณเป็นอันดับแรก
• ออกจากระบบอัตโนมัติ: หลังจากเสร็จสิ้นการทำธุรกรรมโดยใช้บริการของเรา โปรดอย่าลืมออกจากระบบ หากคุณลืมออกจากระบบ ระบบจะออกจากระบบโดยอัตโนมัติในช่วงเวลาที่เหมาะสมเพื่อความปลอดภัยของคุณ
6. การแก้ไขนโยบายความเป็นส่วนตัว
เราขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลาตามดุลยพินิจของเราแต่เพียงผู้เดียวและเป็นที่สิ้นสุด นโยบายที่ประกาศ ณ เวลาใด ๆ คือนโยบายที่มีผลบังคับใช้ในขณะนั้น เวอร์ชันปัจจุบันจะอยู่ที่แอปพลิเคชันนี้เสมอ เราขอแนะนำอย่างยิ่งให้คุณตรวจสอบการอัปเดตใดๆ เป็นประจำ การเข้าถึงหรือการใช้แอปพลิเคชันนี้หรือบริการของเราหลังจากการเปลี่ยนแปลงหรือการแก้ไขใดๆ มีผลบังคับใช้ถือเป็นการรับทราบและยอมรับนโยบายใหม่ของคุณ`,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #fefefe;
}
.imgBox1
{
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}
.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3700px;
  background-color: #FFFFFF;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}
.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.imgItem2 {
  max-width: 100%;
}
.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}
h1{
  margin-top: 50px;
 margin-left: 490px;
 color: #3F4842;
 font-size: 40px;
/* border-bottom: 5px solid #04358A; */
display: inline-block;
}
.textBox{
  /* margin-top: 50px; */
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}
.imgBox2{
  /* transform: scale(90%); */
  transform: scale(90%);
  margin: -140px auto 0px;
  height: 2700px;
  /* box-shadow:0 6px 10px rgba(0, 0, 0, 0.25); */
}

.title-line{
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 5px solid #0BAF60;
  margin: 0 500px;
}
.img1{
  margin-top: 50px;
  /* padding: 0 200px; */
}
</style>